import api from './API';
import { BackendPermission } from '../interfaces';

export const getPermissions = () => api.get<BackendPermission[]>('/rbac');
